import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionsService } from '../permissions.service';

@Directive({
    standalone: true,
    selector: '[hasPermissions]'
})
// todo: Angular migration: need to implement attributes from old directive hasPermissions.js:
// 1.  permissionResult
// 2. projectId
// 3. permissionProjectId
// 4. permissionClass
export class HasPermissionsDirective {
    private hasView = false;

    constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private svc: PermissionsService) {}

    @Input() set hasPermissions(condition: string) {
        if (this.svc.hasPermissions(condition) && !this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
        } else if (!this.svc.hasPermissions(condition) && this.hasView) {
            this.viewContainer.clear();
            this.hasView = false;
        }
    }
}
